// import VConsole from 'vconsole';
// new VConsole();
import Vue from 'vue'
import App from './App.vue'


import Vant from 'vant';
import 'vant/lib/index.css';

import { Tabbar, TabbarItem } from 'vant';

Vue.use(Tabbar);
Vue.use(TabbarItem);

import { Divider } from 'vant';

Vue.use(Divider);
Vue.use(Vant);
import { Swipe, SwipeItem } from 'vant';

import { Icon } from 'vant';

Vue.use(Icon);

Vue.use(Swipe);
Vue.use(SwipeItem);

import VueRouter from 'vue-router';

Vue.use(VueRouter)
import router from './router'

import { TreeSelect } from 'vant';

Vue.use(TreeSelect);

import { Lazyload } from 'vant';

Vue.use(Lazyload);

import { GoodsAction, GoodsActionIcon, GoodsActionButton } from 'vant';

Vue.use(GoodsAction);
Vue.use(GoodsActionButton);
Vue.use(GoodsActionIcon);

import { Sku } from 'vant';

Vue.use(Sku);

import { Toast } from 'vant';

Vue.use(Toast)

import { Uploader } from 'vant';

Vue.use(Uploader);

import { AddressEdit } from 'vant';

Vue.use(AddressEdit);

import { AddressList } from 'vant';

Vue.use(AddressList);

import { Dialog } from 'vant';

Vue.use(Dialog);


import { Popup } from 'vant';

Vue.use(Popup);

import { RadioGroup, Radio } from 'vant';

Vue.use(Radio);
Vue.use(RadioGroup);

import { List } from 'vant';

Vue.use(List);




import store from './vuex/store'
Vue.config.productionTip = false


import directives from '@/directives/index' // 从 directives 目录导入所有指令

// 批量全局注册指令
Object.keys(directives).forEach(key => {
  Vue.directive(key, directives[key]) // 核心注册方法
})

new Vue({
  render: function (h) { return h(App) },
  router,
  store
}).$mount('#app')


